import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"

import tokens from "../_tokens"
import { ButtonInvisible, Icon, Link } from "./"
import { Draggable } from "react-beautiful-dnd"

const ButtonRemove = props => (
  <ButtonInvisible {...props}>
    <Icon name="trash" width="20" height="20" />
  </ButtonInvisible>
)

const StyledButtonGroup = styled.span`
  color: ${tokens.color.primary};
  display: flex;
  opacity: 0;
  margin-left: auto;
  align-items: center;
`

const DragHandle = styled.span`
  position: absolute;
  left: 0;
  transition: all 0.15s ease-in-out 0s;
  cursor: pointer;
  opacity: 0;
  transform: translate(-24px, -50%);

  display: flex;
  top: 50%;
  transform: translateY(-50%);
  width: 20px;
  height: 18px;
  padding: 10px 0;
  overflow: hidden;
  line-height: 5px;
  vertical-align: middle;
  font-size: 11px;
  font-family: sans-serif;
  letter-spacing: 1px;
  color: ${tokens.color.text.light};
  text-shadow: 1px 0 1px ${tokens.color.text.muted};

  &::after {
    content: ".. .. ..";
  }
`

const StyledItemWrapper = styled.span`
  user-select: none;
  cursor: pointer;
  background: ${tokens.color.white};
  /* padding: 5px 10px; */
  border: ${props =>
    props.isDragging ? "1px solid " + tokens.color.primary : "0"};
  display: inline-flex;
  width: 100%;
  display: flex;
  align-items: center;
`

const NavItemEditable = ({
  item,
  index,
  isParent,
  dragHandleProps,
  deleteItem,
}) => {
  const Buttons = () =>
    isParent ? (
      <StyledButtonGroup>
        <ButtonRemove
          css={{ marginLeft: "5px" }}
          id={item.url}
          isParentItem={isParent}
          onClick={deleteItem}
        />
      </StyledButtonGroup>
    ) : (
      <StyledButtonGroup>
        <ButtonRemove
          isParentItem={isParent}
          id={item.url}
          onClick={deleteItem}
        />
      </StyledButtonGroup>
    )

  const Item = ({ dragHandleProps, ...props }) => (
    <>
      <DragHandle {...dragHandleProps} />
      {/* TODO: Removed until further discussion */}
      {/* <EditableInput
        id={item.id}
        url={item.url}
        text={item.title}
        changeMenuItem={changeMenuItem.bind(this)}
        {...props}
      /> */}
      <NavItemPlain item={item} {...props} />
      <Buttons />
    </>
  )

  Item.propTypes = {
    dragHandleProps: PropTypes.object,
  }

  return isParent ? (
    <StyledItemWrapper>
      <Item dragHandleProps={dragHandleProps} />
    </StyledItemWrapper>
  ) : (
    <Draggable draggableId={item.url} index={index} key={item.url}>
      {(provided, snapshot) => (
        <>
          <StyledItemWrapper
            style={{ display: "flex" }}
            ref={provided.innerRef}
            isDragging={snapshot.isDragging}
            {...provided.draggableProps}
          >
            <Item dragHandleProps={provided.dragHandleProps} />
          </StyledItemWrapper>
          {provided.placeholder}
        </>
      )}
    </Draggable>
  )
}

NavItemEditable.propTypes = {
  deleteItem: PropTypes.func,
  dragHandleProps: PropTypes.object,
  index: PropTypes.number,
  isParent: PropTypes.bool,
  item: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    url: PropTypes.string,
  }),
}

const StyledNavLink = styled(Link)`
  font-size: inherit;
  color: inherit;
  padding: 5px 10px;
  display: block;
  &.active {
    font-weight: 700;
  }
`

const NavItemPlain = ({ item, ...props }) => (
  <StyledNavLink
    to={item.url}
    activeClassName="active"
    partiallyActive={true}
    {...props}
  >
    {item.title}
  </StyledNavLink>
)

NavItemPlain.propTypes = {
  item: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
}

const StyledNavItem = styled.li`
  list-style: none;
  position: relative;
  flex-wrap: nowrap;
  display: flex;

  font-size: inherit;
  color: ${({ isParent }) =>
    isParent ? tokens.color.base : tokens.color.primary};
  // Don't use margin on child items, it breaks react-beautiful-dnd styling
  margin-bottom: ${({ isParent }) =>
    isParent ? `${2 * tokens.size.base}px` : `0`};

  &:hover ${DragHandle} {
    opacity: 1;
    transform: translate(-10px, -50%);
  }

  &:hover ${StyledButtonGroup} {
    opacity: 1;
  }
`

const NavItem = ({
  item,
  children,
  index,
  isParent,
  changeMenuItem,
  deleteItem,
  ...props
}) => {
  return (
    <StyledNavItem isParent={isParent}>
      {__EDIT__ ? (
        <NavItemEditable
          item={item}
          index={index}
          isParent={isParent}
          changeMenuItem={changeMenuItem}
          deleteItem={deleteItem}
          {...props}
        >
          {children}
        </NavItemEditable>
      ) : (
        <StyledItemWrapper>
          <NavItemPlain item={item} {...props}>
            {children}
          </NavItemPlain>{" "}
        </StyledItemWrapper>
      )}
    </StyledNavItem>
  )
}

NavItem.propTypes = {
  deleteItem: PropTypes.func,
  changeMenuItem: PropTypes.func,
  children: PropTypes.node,
  index: PropTypes.number,
  isParent: PropTypes.bool,
  item: PropTypes.object,
}

export default NavItem
